export default __webpack_public_path__ + "static/media/movies_dark.fd9df901.png";